<app-navbar-style-one></app-navbar-style-one>

<div class="custom-page-header-section">
    <div class="container-fluid">
        <div class="row pt-5">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex justify-content-center align-items-center menu-header-section">
                <div class="ms-5">
                    <h2>Checkout </h2>
                    <p class="mt-4 mb-0 mx-3">Here’s your order so far! Double-check your dishes, adjust portions, or add something tasty before you checkout</p>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 text-center before-img-section">
                <img src="../../../assets/img/home2/cart.png" alt="Menu Page" class="img-fluid">
            </div>
        </div>
    </div>
</div>

<section class="success-section mt-5">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <img src="../../../../assets/img/home2/box.png" class="itemImage" width="220" alt="success">
                <p class="successParagraph">"Thank you! Your order has been placed successfully"</p>
                <a href="mainMenu" class="btn btn-primary">Continue Shopping</a>
            </div>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>